import { render } from "./LeaveEntitlementTable.vue?vue&type=template&id=4733eb1e"
import script from "./LeaveEntitlementTable.vue?vue&type=script&lang=js"
export * from "./LeaveEntitlementTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__